import {
    REFURBISH_DEVICE_OPEN_MODAL,
    REFURBISH_DEVICE_CLOSE_MODAL,
    REFURBISH_DEVICE_REQUEST,
    REFURBISH_DEVICE_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case REFURBISH_DEVICE_OPEN_MODAL:
            return { ...state, openModal: true }

        case REFURBISH_DEVICE_CLOSE_MODAL:
            return { ...state, openModal: false }

        case REFURBISH_DEVICE_REQUEST:
            return { ...state, loading: true }

        case REFURBISH_DEVICE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "REFURBISH_DEVICE"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
                
        default:
            return state;
    }
};